export const storyParagraphs = [
  'Josh has worked in content and digital marketing since 2017. But his path into growth strategy did not start with a textbook — it started with a real, personal pressure to make marketing actually work.',
  'Early in their marriage, Josh and his wife were carrying roughly $300,000 in student loan debt. That reality forced them to take business and marketing seriously — not as a side interest, but as a way to build a more stable, more intentional future.',
  'What began as solving their own problem gradually became helping other business owners build stronger marketing systems. Josh and Lauren Hastings went on to build HFE Marketing Group LLC around helping business owners grow online.',
  'That grounding — understanding what it feels like to need marketing to work — still shapes how Josh advises every business he works with today.',
];

export const storyQuote =
  'We had to figure out how to make marketing actually work for our own future. Eventually, that became helping other business owners do the same.';

export const timeline = [
  {
    year: '2017',
    title: 'Started Working in Digital Marketing',
    desc: 'Content, strategy, and online marketing — learning what actually generates attention, engagement, and leads.',
  },
  {
    year: 'Growth Years',
    title: 'Moved Beyond Tactics',
    desc: 'Shifted from isolated tactics to understanding how websites, advertising, CRM, follow-up, and customer acquisition work together as one system.',
  },
  {
    year: 'HFE Marketing Group',
    title: 'Built a Business Around Growth Systems',
    desc: 'Josh and Lauren developed the business around helping owners improve how they market and grow online.',
  },
  {
    year: 'Today',
    title: 'Strategy + Implementation',
    desc: 'Helping established service businesses through Done For You Marketing and Done With You Consulting.',
  },
];

export const philosophy = [
  {
    icon: 'ri-pie-chart-2-line',
    title: 'Measure What Matters',
    desc: 'Marketing should ultimately connect to leads, customers, revenue, and business growth.',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Build Systems, Not Shortcuts',
    desc: 'Avoid gimmicks and temporary hacks. Build systems the business can actually depend on.',
  },
  {
    icon: 'ri-layout-grid-line',
    title: 'Strategy Must Fit the Business',
    desc: 'Different markets, teams, offers, and service areas require different strategies.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Execution Matters',
    desc: 'A strong strategy means very little without proper implementation, optimization, and follow-through.',
  },
];

export const whoBestWith = [
  'Established home-service and local-service businesses',
  'Businesses with existing traction and real demand',
  'Owners who want measurable, revenue-focused marketing',
  'Teams ready to implement and optimize',
  'Businesses seeking more predictable lead generation',
  'Companies prepared to invest in growth, not chase shortcuts',
];

export const resultCards = [
  { value: '200%', label: 'Above Annual Goal' },
  { value: '$500K+', label: 'Record Client Month' },
  { value: '$550K', label: 'Largest Month for a Client' },
];
